"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PermissionTooltip = require("./PermissionTooltip.styled");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var PermissionTooltip = function PermissionTooltip(_ref) {
  var displayTooltip = _ref.displayTooltip,
    targetElementId = _ref.targetElementId,
    _ref$requiredRole = _ref.requiredRole,
    requiredRole = _ref$requiredRole === void 0 ? 'Show caller' : _ref$requiredRole;
  if (!displayTooltip) return null;
  return /*#__PURE__*/_react["default"].createElement(_PermissionTooltip.TooltipStyled, {
    placement: 'bottom',
    target: targetElementId,
    style: _PermissionTooltip.TooltipInlineStyle
  }, "".concat(requiredRole, " permission is required"));
};
PermissionTooltip.propTypes = {
  requiredRole: _propTypes["default"].string,
  displayTooltip: _propTypes["default"].bool.isRequired,
  targetElementId: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(PermissionTooltip);